import './style.scss';

import React, {PropTypes} from 'react';
import $ from 'jquery';

let lastMessages = null;

const FlashMessage = ({messages, formatMessage}) => {
    if (messages !== lastMessages) {
        lastMessages = messages;
        messages.forEach((msg) => {
            let flash = formatMessage({id: msg.messageIds[0] }, msg.params);
            if (msg.titleId) {
                let title = formatMessage({id: msg.titleId});
                flash = $(`<div class="toast-big"><span class="toast-title">${title}</span><span class="toast-body">${flash}</span></div>`);
            }
            // eslint-disable-next-line no-undef
            Materialize.toast(flash, msg.ttl, msg.theme);
        });
    }
    return <div className="hide">flashmsg</div>;
};

FlashMessage.propTypes = {
    messages: PropTypes.object.isRequired,
    formatMessage: PropTypes.func.isRequired
};

export default FlashMessage;
